'use client'

import { useMapDispatch } from 'maps/hooks/useMapDispatch/useMapDispatch'
import { useMapState } from 'maps/hooks/useMapState/useMapState'
import { getStoreDetail } from 'maps/services/client/getStoreDetail/getStoreDetail'
import type { Store } from 'maps/types'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'

export function useExpandedStore() {
	const {
		country: { countryISO, languageISO },
		channel,
	} = useMasterData()
	const { expanded, stores, filteredStores } = useMapState()
	const dispatch = useMapDispatch()

	const setExpanded = async (store?: Store, filteredStoresParam?: Store[]) => {
		const newFilteredStores = filteredStoresParam ?? filteredStores

		if (!store) {
			dispatch({ expanded: undefined })
			return
		}

		if (store.details) {
			dispatch({ expanded: store })
			return
		}

		const storeWithDetail =
			(await getStoreDetail({
				id: store.id,
				countryISO,
				languageISO,
				channel,
			})) ?? store

		const newStore = { ...store, details: storeWithDetail.details }

		const updatedStores = stores?.map((prevStore) =>
			prevStore.id === store.id ? newStore : prevStore
		)
		const updateFilteredStores = newFilteredStores?.map((prevFilteredStore) =>
			prevFilteredStore.id === store.id ? newStore : prevFilteredStore
		)

		dispatch({
			expanded: newStore,
			stores: updatedStores,
		})

		if (updateFilteredStores && updateFilteredStores?.length > 0) {
			dispatch({ filteredStores: updateFilteredStores })
		}
	}

	return { expanded, setExpanded }
}
